var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.cssClass,attrs:{"href":_vm.status.details_path,"title":!_vm.showText ? _vm.status.text : ''}},[_c('ci-icon',{attrs:{"status":_vm.status}}),_vm._v(" "),(_vm.showText)?[_vm._v("\n    "+_vm._s(_vm.status.text)+"\n  ")]:_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a93a9e9","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_badge_link.vue
// module id = null
// module chunks = 